import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const formatBRL = (value) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

export const CabanaCard = ({ cabana, index = 0 }) => {
  return (
    <Link
      to={`/cabana/${cabana.id}`}
      data-testid={`cabana-card-${cabana.id}`}
      className="group flex flex-col cursor-pointer bg-white border border-[#E3DCD2] hover:shadow-[0_18px_48px_-12px_rgba(44,85,69,0.18)] transition-all duration-500"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F2EFE9]">
        <img
          src={cabana.images[0]}
          alt={cabana.name}
          loading={index < 2 ? "eager" : "lazy"}
          className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[900ms] ease-out"
        />
        <div className="absolute top-4 left-4 px-3 py-1.5 bg-[#F9F6F0]/95 backdrop-blur-sm text-[10px] uppercase tracking-[0.2em] font-bold text-[#1A2421]">
          0{index + 1}
        </div>
      </div>

      <div className="p-6 lg:p-8 flex flex-col gap-4 flex-1">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-2xl lg:text-3xl font-bold text-[#1A2421] tracking-tight leading-tight">
              {cabana.name}
            </h3>
          </div>
          <span className="w-10 h-10 flex items-center justify-center border border-[#E3DCD2] group-hover:bg-[#2C5545] group-hover:border-[#2C5545] group-hover:text-white transition-colors">
            <ArrowUpRight size={16} strokeWidth={1.8} />
          </span>
        </div>

        <p className="text-sm text-[#5C6661] leading-relaxed flex-1">
          {cabana.short}
        </p>

        <div className="flex items-end justify-between pt-4 border-t border-[#E3DCD2]">
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#5C6661] font-bold">
              Diária a partir de
            </p>
            <p className="text-2xl font-black text-[#2C5545] tracking-tight">
              {formatBRL(cabana.price)}
            </p>
          </div>
          <span className="text-xs text-[#1A2421] font-bold uppercase tracking-[0.15em] underline-offset-4 group-hover:underline">
            Reservar
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CabanaCard;
